<div class="resource-card">
  <div class="resource-card__title">
    <img
      [src]=getResourceIconUrl()
      [alt]="resource?.resourceName">
    <div class="data">
      <span *ngIf="resource.resourceName === resourceType.OXYGEN">{{resource.resourceName}}</span>
      <span
        *ngIf="resource.resourceName === resourceType.MEDICINE || resource.resourceName === resourceType.MEDICAL_KIT"
      >
        {{resource?.name | titlecase}}
      </span>
      <span *ngIf="resource.resourceName === resourceType.BLOOD">{{resource?.bloodGroup}}</span>
      <small class="location">{{resource?.state | titlecase}} - {{resource?.city | titlecase}}</small>
    </div>
  </div>
  <div class="update" *ngIf="!!showDelete && resource?.resourceName !== resourceType.BLOOD">
    <button [disabled]="resource?.quantity <= 1" mat-icon-button (click)="updateResource(resource._id, resource.quantity - 1)">
      <mat-icon>remove</mat-icon>
    </button>
    <p>{{resource.quantity}}</p>
    <button mat-icon-button (click)="updateResource(resource._id, resource.quantity + 1)">
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <button *ngIf="!!showDelete" mat-icon-button color="warn" (click)="deleteResource(resource._id)">
    <mat-icon>delete</mat-icon>
  </button>
  <button
    *ngIf="!!showCall"
    mat-icon-button
    color="primary"
    [matTooltip]="resource?.phoneNumber"
    [cdkCopyToClipboard]="resource?.phoneNumber"
    (click)="copiedAlert()"
    matTooltipPosition="right">
    <mat-icon>call</mat-icon>
<!--    <span>{{resource?.phoneNumber}}</span>-->
  </button>
</div>
